module.exports = __webpack_public_path__ + "static/media/default-social-sharing-image-en.8d702085.png";